// extracted by mini-css-extract-plugin
export default {"section":"courseDesign_section__yrBlN","title":"courseDesign_title__QJysZ","design_form":"courseDesign_design_form__ZFOVy"};